import { render, staticRenderFns } from "./relativePeople.vue?vue&type=template&id=13421589&scoped=true&"
import script from "./relativePeople.vue?vue&type=script&lang=js&"
export * from "./relativePeople.vue?vue&type=script&lang=js&"
import style0 from "./relativePeople.vue?vue&type=style&index=0&id=13421589&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13421589",
  null
  
)

export default component.exports